import { render, staticRenderFns } from "./eNPS.vue?vue&type=template&id=20e83c0a&scoped=true&"
import script from "./eNPS.vue?vue&type=script&lang=js&"
export * from "./eNPS.vue?vue&type=script&lang=js&"
import style0 from "./eNPS.vue?vue&type=style&index=0&id=20e83c0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e83c0a",
  null
  
)

export default component.exports